import dayjs from 'dayjs'

export function parseDateToString (date: Date): string {
  return dayjs(date).format('DD-MM-YYYY')
}
